{
  "zh-TW": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> 瀏覽",
          "other": "%{label}:<br><b>%{count}</b> 瀏覽"
        },
        "pledgePrice": "%{label}:<br><b>%{count}</b> USD",
        "ingamePrice": "%{label}:<br><b>%{count} %</b>",
        "wishToOwnRatio": "%{label}:<br>每 100 艘擁有對應的期待數: <b>%{count}</b>",
        "patchChange": {
          "one": "%{label}:<br><b>%{count}</b> 處改動",
          "other": "%{label}:<br><b>%{count}</b> 處改動"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> 飛船",
          "other": "%{label}:<br><b>%{count}</b> 飛船"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> 飛船 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 飛船 (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> 組件 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 組件 (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> 使用者",
          "other": "%{label}:<br><b>%{count}</b> 使用者"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> User (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Users (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> 訪問",
          "other": "%{label}:<br><b>%{count}</b> 訪問"
        },
        "supporterContribution": {
          "amount": "捐助：<b>%{amount}</b>",
          "goal": "目標：<b>%{amount}</b>",
          "count": {
            "one": "<b>%{count}</b> 位支持者",
            "other": "<b>%{count}</b> 位支持者"
          }
        }
      },
      "states": {
        "empty": "尚無可繪製的資料",
        "failed": "無法載入此圖表",
        "retry": "重試"
      }
    }
  }
}
